import gql from "graphql-tag";

export const SUBSCRIBE_LR = gql`
subscription subscribeLR($startDate:timestamptz!, $endDate:timestamptz!, $search: String!){
 lr(where: {_and: [{ created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}},
    {_or: [{lrNumber: {_ilike: $search}},{Order: {orderNumber: {_ilike: $search}}},
    {Consignor: {name: {_ilike: $search}}},{Consignee: {name: {_ilike: $search}}}, ]}, ]}, order_by: {created_at: desc}) {
   id
   lrNumber
   Consignor {id name address}
   Consignee {id name address}
   PickupCompany {id name address}
   DropCompany {id name address}
   PickupAddress {id addressLine1 addressLine2 area city state pincode}
   DropAddress {id addressLine1 addressLine2 area city state pincode}
   transportVehicle
   status
   Order{
     id
     orderNumber
     priority
     materials
     pickuppartyobject
     droppingpartyobject
     internalstatus
     internalStatus{id name viewPath}
     orderDetails{
        id
        pickupPoint
        dropPoint
        PIckupTempo{ id tempo{id platNo} driverDetail{id name mobile} }
        PickupTruck{ id truck{id platNo} driverDetail{id name mobile} }
        truckOrder{ id truck{id platNo} driverDetail{id name mobile} }
      }
   }
   created_at
  }
}
`
